import { render, staticRenderFns } from "./instagramStories.vue?vue&type=template&id=3448a4b6&scoped=true&"
import script from "./instagramStories.vue?vue&type=script&lang=js&"
export * from "./instagramStories.vue?vue&type=script&lang=js&"
import style0 from "./instagramStories.vue?vue&type=style&index=0&id=3448a4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448a4b6",
  null
  
)

export default component.exports